import Backbone from 'backbone';
import ControlsView from './ControlsView';

export default Backbone.View.extend({
  initialize(o) {
    let config = o.config;
    this.ControlsView = new ControlsView({
      collection: o.collection,
      config: config,
      gconfig: o.gconfig
    });
    this.url = o.gconfig.url;
    this.rootdir = o.gconfig.rootDir;
    this.em = config.em;
  },

  events: {
    'click .header .close_icon img': 'close',
    'input .control-search input': 'search'
  },

  template() {
    return `<div class="header">
              <div class="icon-holder"><img src="${this.url}app/src/images/studio.svg"> Designer</div>
              <div class="control-search">
                  <img src="${this.url}static/images/Search icon.svg">
                  <input type="text" placeholder="seach">
              </div>
              <div class="close_icon"><img src="${this.rootdir}/assets/images/close.svg"></div>
            </div>
            `;
  },

  search(e) {
    let value = e.target.value.toLowerCase();
    this.collection.forEach(function(model) {
      let dis_name = model.get('display_name').toLowerCase();
      if (dis_name.indexOf(value) > -1) {
        model.view.show();
      } else {
        model.view.hide();
      }
    });
  },

  close() {
    this.remove();
  },

  render() {
    this.$el.empty();
    this.$el.append(this.template());
    this.$el.append(this.ControlsView.render().$el);
    this.$el.addClass('control_list_wrapper');
    if (!this.em.config.current_control) {
      this.$el.find('.header .close_icon img').hide();
    }
    return this;
  }
});
